import React from 'react';
import { useState } from "react";
import getUrl from "../../../Utility/GetUrl";
import { postData } from "../../../Utility/GlobalService";
import TextAreaInput from "../Components/textareaInput";
import TextInput from "../Components/textInput";

const DashboardContact = ()=> { 
  const [contactSectionTitle,setContactSectionTitle] = useState("");
  const [contactSectionContent,setContactSectionContent] = useState("");
  const [email,setEmail] = useState();
  const [address,setAddress] = useState();
  const [phone,setPhone] = useState();
  
  const postContactTitle = (event)=>{
    event.preventDefault();
    const data = {
      title: contactSectionTitle
    };
    postData(`${getUrl()}/contact/title`,data);
    setContactSectionTitle("");
  }
  const postContactContent = (event)=>{
    event.preventDefault();
    const data = {
      content: contactSectionContent
    };
    postData(`${getUrl()}/contact/content`,data);
    setContactSectionContent("");
  }
  const postContactPhone = (event)=>{
    event.preventDefault();
    const data = {
      phone
    };
    postData(`${getUrl()}/contact/phone`,data);
    setPhone("");
  }
  const postContactEmail = (event)=>{
    event.preventDefault();
    const data = {
      email
    };
    postData(`${getUrl()}/contact/email`,data);
    setEmail("");
  }
  const postContactAddress = (event)=>{
    event.preventDefault();
    const data = {
      address
    };
    postData(`${getUrl()}/contact/address`,data);
    setAddress("");
  }
    return (
      <div style = {{paddingBottom: '100px'}}
      className="dashboard-home mb-5">
          <div className="container mb-5">
            <div className="row">
              <div className="col-md-12">
                <h2>Contact Page</h2>
              </div>
            </div>
            <div className="row mt-5">
            <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Contact Page Title</h5>
                  <TextInput
                    handleInputSubmit = {postContactTitle}
                    setInputValue = {setContactSectionTitle}
                    inputValue ={contactSectionTitle}
                  />
                  <TextAreaInput
                    handleSectionContent = {postContactContent}
                    sectioncontent = {contactSectionContent}
                    setSectionContent ={setContactSectionContent}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
              <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Address</h5>
                  <TextAreaInput
                    title = "Address"
                    handleSectionContent = {postContactAddress}
                    sectioncontent = {address}
                    setSectionContent ={setAddress}
                  />
                </div>
              </div>
              </div>
            </div>
            <div className="row mt-5">
            <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Email</h5>
                  <TextInput
                    textType = "email"
                    title = "Email"
                    buttonText = "Add"
                    handleInputSubmit = {postContactEmail}
                    setInputValue = {setEmail}
                    inputValue ={email}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-1"></div>
              <div className="col-md-5">
              <div className="card">
                <div className="card-body mb-auto">
                  <h5>Contact Phone</h5>
                  <TextInput
                    textType = "number"
                    title = "Contact"
                    buttonText = "Add"
                    handleInputSubmit = {postContactPhone}
                    setInputValue = {setPhone}
                    inputValue ={phone}
                  />
                </div>
              </div>
              </div>
            </div>
          </div>
      </div>
    );

  }
  
  export default DashboardContact; 